<ng-container *ngIf="href; else buttonTemplate">
  <a
    class="link"
    [href]="href"
    [target]="getTarget()"
    [tabIndex]="tabIndex">
    <ng-container [ngTemplateOutlet]="buttonTemplate"></ng-container>
  </a>
</ng-container>

<ng-template #buttonTemplate>
  <button
    #button
    class="generic-button"
    matTooltipClass="mg-tooltip"
    matRipple
    matRippleColor="rgba(255, 255, 255, .10)"
    [matRippleDisabled]="disabled || loading"
    [ngClass]="classes"
    [disabled]="disabled || loading"
    [attr.form]="attrFormId"
    [attr.type]="attrType"
    [matTooltip]="tooltip"
    [tabIndex]="tabIndex"
    [attr.data-test]="id">
    <!-- File Input -->
    <ng-content select="[fileInput]"></ng-content>
    <!-- Left Icon Container -->
    <div
      class="icon-container"
      *ngIf="icon || loading">
      <!-- Loading Spinner -->
      <mat-spinner
        *ngIf="loading"
        [diameter]="20"
        [color]="variant === 'outlined' ? 'accent' : 'primary'"
        [strokeWidth]="2">
      </mat-spinner>
      <ng-container
        *ngIf="!loading"
        [ngTemplateOutlet]="iconTemplate"
        [ngTemplateOutletContext]="{
          icon: {
            name: icon,
            color: iconColor,
            variant: iconVariant
          }
        }">
      </ng-container>
    </div>

    <div
      *ngIf="iconSvg"
      class="icon-svg left">
      <img
        [src]="iconSvg"
        alt="icon" />
    </div>

    <!-- Text -->
    <span
      *ngIf="this.variant !== 'icon' && this.variant !== 'icon-secondary' && this.variant !== 'icon-destructive'"
      fontWeight="700">
      <ng-content></ng-content>
    </span>

    <!-- Right Icon Container -->
    <div
      class="icon-container"
      *ngIf="iconRight">
      <ng-container
        [ngTemplateOutlet]="iconTemplate"
        [ngTemplateOutletContext]="{
          icon: {
            name: iconRight,
            color: iconColorRight,
            variant: iconVariantRight
          }
        }">
      </ng-container>
    </div>
  </button>
</ng-template>

<!-- Icon Template -->
<ng-template
  #iconTemplate
  let-icon="icon">
  <ng-container [ngSwitch]="iconSet">
    <mat-icon
      *ngSwitchCase="'material'"
      aria-hidden="false">
      {{ icon.name }}
    </mat-icon>
    <mg-icon
      [ngClass]="{ 'icon-variant': icon.variant }"
      *ngSwitchDefault
      [iconColor]="icon.color"
      [variant]="icon.variant"
      [iconName]="icon.name">
    </mg-icon>
  </ng-container>
</ng-template>
